<template>
  <div>
    <div v-if="errors.length >= 1">
      {{ errors }}
    </div>
    <card>
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            List of Incase
            <vuetable ref="rooms"
                      :fields="columns"
                      :api-mode="false"
                      :data="incase"
            ></vuetable>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { IncaseAPIService } from '../../servicehandlers/IncaseHandler';
import loginCheckMixin from '@/mixin';
import Vuetable from 'vuetable-2'

const incaseAPIService = new IncaseAPIService();

export default {
  name: 'Incase',
  components: {
    Vuetable
  },
  mixins: [loginCheckMixin],
  data: () => ({
    state: null,
    login: {},
    errors: [],
    groups: [],
    incase: [],
    options: {},
    long_name: null,
    short_name: null,
    file_id: null,
    columns: ['user', 'email', 'summary'],
  }),

  mounted() {
    this.getShifts();
  },

  methods: {
    // manual submit login detected.
    getShifts() {
      incaseAPIService.getIncases(this.$router)
      .then((resp) => {
        this.incase = resp;
      })
      .catch((error) => {
        console.log('Error: ', error);
      });
    },
  },
}
</script>

<style>
input {
  text-align: left;
}
</style>

